"use strict";

var _interopRequireWildcard = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var $wl = _interopRequireWildcard(require("@/utils/wl-utils"));
function _default(el /* , binding, vnode, oldVnode */) {
  if (el.getAttribute('dialog-tool-stretch') !== null) return;
  var a = el.querySelector('.el-dialog');

  /* 首先创建四条线 */
  var b = [document.createElement('div')];
  b[0].style.cssText += ';position: absolute;z-index: 1;margin: 0;padding: 0;';
  b.push(b[0].cloneNode(true));
  b.push(b[0].cloneNode(true));
  b.push(b[0].cloneNode(true));
  b.push(b[0].cloneNode(true));
  b.push(b[0].cloneNode(true));
  b.push(b[0].cloneNode(true));
  b.push(b[0].cloneNode(true));
  b.push(b[0].cloneNode(true));
  var n = 20;
  b[0].className += 'background';
  b[0].style.cssText += ";position: fixed;top: 0;left: 0;z-index: -1;width: 100vw;height: 100vh;";
  b.forEach(function (dom, index) {
    if (!index) return;

    /* 定义类名 */
    var className = 'drag-border drag-border-';
    switch (index) {
      case 1:
        className += 'top-left';
        break;
      case 2:
        className += 'top';
        break;
      case 3:
        className += 'top-right';
        break;
      case 4:
        className += 'left';
        break;
      case 5:
        className += 'right';
        break;
      case 6:
        className += 'bottom-left';
        break;
      case 7:
        className += 'bottom';
        break;
      case 8:
        className += 'bottom-right';
        break;
    }
    var domTmp = a.querySelectorAll(".".concat(className.replace(' ', '.')));
    if (domTmp.length) dom = a.querySelector(".".concat(className.replace(' ', '.')));else a.append(dom);

    /* 鼠标样式 */
    var cursor = '';
    switch (index) {
      case 2:
      case 7:
        cursor = 'ns-resize';
        break;
      case 4:
      case 5:
        cursor = 'ew-resize';
        break;
      case 1:
      case 8:
        cursor = 'nwse-resize';
        break;
      case 3:
      case 6:
        cursor = 'nesw-resize';
        break;
    }
    if (![2, 7].includes(index)) dom.style.cssText += ";width: ".concat(n, "px;");else dom.style.cssText += ";width: 100%;";
    if (![4, 5].includes(index)) dom.style.cssText += ";height: ".concat(n, "px;");else dom.style.cssText += ";height: 100%;";
    if ([1, 4, 6].includes(index)) dom.style.cssText += ";left: -".concat(n / 2, "px;");
    if ([3, 5, 8].includes(index)) dom.style.cssText += ";right: -".concat(n / 2, "px;");
    if ([1, 3, 6, 8].includes(index)) dom.style.cssText += ";z-index: 2;";
    if (index <= 3) dom.style.cssText += ";top: -".concat(n / 2, "px;");
    if (index >= 6) dom.style.cssText += ";bottom: -".concat(n / 2, "px;");
    var cancel = function cancel() {
      var _a$querySelector;
      el.onmousemove = null;
      el.onmouseup = null;
      dom.onmouseleave = null;
      (_a$querySelector = a.querySelector('.background')) === null || _a$querySelector === void 0 || _a$querySelector.remove();
    };

    // el.onmouseleave = cancel

    /* 事件 */
    dom.onmousedown = function (e0) {
      /* 设置对话框的绝对定位 */
      var top = a.offsetTop + 'px';
      var left = a.offsetLeft + 'px';
      Object.assign(a.style, {
        position: 'absolute',
        top: top,
        left: left
      });
      a.append(b[0]);
      /* 获取鼠标当前位置（鼠标相对页面可视区域位置） */
      var x0 = e0.clientX;
      var y0 = e0.clientY;

      /* 获取鼠标当前位置，距离当前元素的边界距离 */
      var p1 = {
        l: a.offsetLeft,
        t: a.offsetTop
      };

      /* 获取对话框尺寸 */
      var d1 = {
        w: a.offsetWidth,
        h: a.offsetHeight
      };
      el.onmousemove = function (e1) {
        /* 获取鼠标当前 X轴 位置 */
        var x1 = e1.clientX;
        var y1 = e1.clientY;
        /* 计算鼠标当前位置与刚按下的时候位置偏移量 */
        var x = x1 - x0;
        var y = y1 - y0;
        $wl.debounce(function () {
          if (index < 4) a.style.cssText += ";top: ".concat(p1.t + y, "px;height: ").concat(-y + d1.h, "px");
          if ([6, 7, 8].includes(index)) a.style.cssText += ";top: ".concat(p1.t, "px;height: ").concat(y + d1.h, "px");
          if ([3, 5, 8].includes(index)) a.style.cssText += ";left: ".concat(p1.l, "px;width: ").concat(x + d1.w, "px");
          if ([1, 4, 6].includes(index)) a.style.cssText += ";left: ".concat(p1.l + x, "px;width: ").concat(-x + d1.w, "px");
        }, 30);
      };

      /* 鼠标抬起事件 */
      el.onmouseup = cancel;
      el.onmouseleave = cancel;
      // dom.onmouseleave = cancel
    };
    dom.style.cssText += "cursor: ".concat(cursor);
  });
  el.setAttribute('dialog-tool-max', '');
}